import { useUser } from 'features/authorized/context/user'

const useStripeLink = () => {
    const { user } = useUser()

    const redirectToStripe = () => {
        const link = user.onboarding?.next_action?.params?.link
        if (!link) {
            return
        }
        window.location.href = link
    }
    return { redirectToStripe }
}
export default useStripeLink
